function doggoAnalyticsAllowed() {
  return (
    window.DoggoConsent &&
    typeof window.DoggoConsent.isAnalyticsAllowed === "function" &&
    window.DoggoConsent.isAnalyticsAllowed()
  );
}

function doggoMarketingAllowed() {
  return (
    window.DoggoConsent &&
    typeof window.DoggoConsent.isMarketingAllowed === "function" &&
    window.DoggoConsent.isMarketingAllowed()
  );
}

document.addEventListener("click", function (e) {
  var btn = e.target.closest(".my-custom-cart-button");

  if (btn) {
    var title = btn.getAttribute("data-product-title") || "Custom Button";
    var leadType = (btn.getAttribute("leadType") || "").trim();
    var leadTypeLower = leadType.toLowerCase();

    var value = null;
    if (leadTypeLower === "grooming") {
      value = 4000;
    } else if (
      leadTypeLower === "dogtraining" ||
      leadTypeLower === "dog training"
    ) {
      value = 35000;
    } else if (leadTypeLower === "pettaxi") {
      value = 500;
    }

    if (typeof gtag === "function" && doggoAnalyticsAllowed()) {
      var eventPayload = {
        currency: "TRY",
        items: [{ item_name: leadType || title }],
      };

      var formElement = btn.closest(".dfb-section")
        ? btn.closest(".dfb-section").querySelector("form")
        : btn.closest("form");
      if (formElement) {
        if (formElement.id) eventPayload.form_id = formElement.id;
        if (formElement.name) eventPayload.form_name = formElement.name;
        if (formElement.action)
          eventPayload.form_destination = formElement.action;
      }

      if (leadType) {
        eventPayload.items[0].item_category = leadType;
        eventPayload.leadType = leadType;
      }

      if (value !== null) {
        eventPayload.value = value;
      }

      var eventName = "form_start";

      gtag("event", eventName, eventPayload);
      console.log("GA4 " + eventName + " Event Sent: " + title);
    }

    if (typeof fbq === "function" && doggoMarketingAllowed()) {
      var pixelPayload = {
        content_name: leadType || title,
        content_category: leadType || "",
        currency: "TRY",
      };

      if (leadType) pixelPayload.serviceType = leadType;
      if (value !== null) {
        pixelPayload.value = value;
      }

      trackDoggoMetaPixelEvent(
        "AddToCart",
        pixelPayload,
        buildDoggoMetaEventId("AddToCart", {
          serviceType: leadType,
          actionTime: Date.now(),
        }),
      );
      console.log("Pixel Add To Cart Event Sent: " + title);
    }
  }
});

document.addEventListener(
  "submit",
  function (e) {
    var form = e.target;

    if (form && form.tagName === "FORM" && form.closest(".dfb-section")) {
      prepareDoggoLeadMetaFields(form);
    }
  },
  true,
);

document.addEventListener("focusin", function (e) {
  var field = e.target;
  var form = field && field.closest ? field.closest("form") : null;

  if (
    !form ||
    form.__doggoMetaFormStarted ||
    typeof fbq !== "function" ||
    !doggoMarketingAllowed()
  ) {
    return;
  }

  var section = form.closest(".dfb-section");
  if (!section) return;

  var btn = section.querySelector(".dfb-trigger-btn.my-custom-cart-button");
  if (!btn) return;

  var title = btn.getAttribute("data-product-title") || "Custom Button";
  var leadType = (btn.getAttribute("leadType") || "").trim();
  var leadTypeLower = leadType.toLowerCase();
  var value = null;

  if (leadTypeLower === "grooming") {
    value = 4000;
  } else if (
    leadTypeLower === "dogtraining" ||
    leadTypeLower === "dog training"
  ) {
    value = 35000;
  } else if (leadTypeLower === "barffood") {
    value = 1000;
  } else if (leadTypeLower === "pettaxi") {
    value = 500;
  }

  if (value === null) return;

  form.__doggoMetaFormStarted = true;
  var formEventInput = getDoggoMetaFormEventInput(form);
  trackDoggoMetaPixelCustomEvent("FormStarted", {
    content_name: leadType || title,
    content_category: leadType || "",
    value: value,
    currency: "TRY",
  }, buildDoggoMetaEventId("FormStarted", formEventInput));
  console.log("Pixel FormStarted Event Sent: " + title);
});

document.addEventListener("submit", function (e) {
  var form = e.target;

  if (form && form.tagName === "FORM") {
    var section = form.closest(".dfb-section");
    if (section) {
      var btn = section.querySelector(".dfb-trigger-btn.my-custom-cart-button");
      if (btn) {
        var title = btn.getAttribute("data-product-title") || "Custom Button";
        var leadType = (btn.getAttribute("leadType") || "").trim();
        var leadTypeLower = leadType.toLowerCase();

        var value = null;
        if (leadTypeLower === "grooming") {
          value = 4000;
        } else if (
          leadTypeLower === "dogtraining" ||
          leadTypeLower === "dog training"
        ) {
          value = 35000;
        } else if (leadTypeLower === "barffood") {
          value = 1000;
        } else if (leadTypeLower === "pettaxi") {
          value = 500;
        }

        if (value !== null) {
          var il = "";
          var ilce = "";
          var petType = "";

          try {
            var formData = new FormData(form);
            for (var pair of formData.entries()) {
              var key = pair[0].toLowerCase();
              var val = (pair[1] || "").toString();

              if (
                !ilce &&
                (key === "contact[district]" || key === "district")
              ) {
                ilce = val;
              } else if (
                !il &&
                (key === "contact[province]" || key === "province")
              ) {
                il = val;
              } else if (
                !petType &&
                (key === "contact[pettype]" || key === "pettype")
              ) {
                var petTypeValue = val.trim().toLowerCase();
                if (petTypeValue === "kedi" || petTypeValue === "cat") {
                  petType = "Cat";
                } else if (
                  petTypeValue === "köpek" ||
                  petTypeValue === "dog"
                ) {
                  petType = "Dog";
                }
              }
            }
          } catch (e) {}

          if (typeof gtag === "function" && doggoAnalyticsAllowed()) {
            var transactionId = leadTypeLower + "_" + new Date().getTime();

            var eventPayload = {
              currency: "TRY",
              value: value,
              items: [{ item_name: leadType || title }],
            };

            if (form) {
              if (form.id) eventPayload.form_id = form.id;
              if (form.name) eventPayload.form_name = form.name;
              if (form.action) eventPayload.form_destination = form.action;
            }

            if (il) eventPayload.province = il;
            if (ilce) eventPayload.district = ilce;
            if (petType) eventPayload.petType = petType;

            if (leadType) {
              eventPayload.items[0].item_category = leadType;
              eventPayload.leadType = leadType;
            }

            if (leadTypeLower === "grooming") {
              eventPayload.transaction_id = transactionId;
            }

            var eventName = "form_submit";

            gtag("event", eventName, eventPayload);
            console.log("GA4 " + eventName + " Event Sent: " + title);
          }

          if (typeof gtag === "function" && doggoMarketingAllowed()) {
            gtag("event", "conversion", {
              send_to: "AW-11272580447/3d7JCIjp8JccEN_al_8p",
            });
            console.log("Google Ads Conversion Event Sent");
          }

          if (typeof fbq === "function" && doggoMarketingAllowed()) {
            var pixelPayload = {
              content_name: leadType || title,
              content_category: leadType || "",
              value: value,
              currency: "TRY",
            };

            if (leadType) pixelPayload.serviceType = leadType;
            if (il) pixelPayload.province = il;
            if (ilce) pixelPayload.district = ilce;

            var leadEventId = prepareDoggoLeadMetaFields(form);
            var submitApplicationEventId = prepareDoggoSubmitApplicationMetaField(form);
            trackDoggoMetaPixelEvent("Lead", pixelPayload, leadEventId);
            trackDoggoMetaPixelEvent(
              "SubmitApplication",
              pixelPayload,
              submitApplicationEventId,
            );
            console.log("Pixel Lead Event Sent: " + title);
          }
        }
      }
    }
  }
});
